import { FC, Fragment } from 'react';

import { BugoData } from '@shared/api/bugo/bugo.interface';
import { cemeteryDisplayRows } from '@shared/api/fevent/feventCemetery.util';
import { groupExtraSchedulesByAnchor } from '@shared/api/fevent/feventExtraSchedule.util';
import { formatFeventDateString } from '@shared/utils/formatDate';

import { ExtraScheduleRows } from './ExtraScheduleRows';

interface Props {
  bugo: BugoData;
}

export const ObituaryFeventGrid: FC<Props> = function ObituaryFeventGrid({
  bugo,
}: Props) {
  const deceasedInfo = bugo.fevent.deceasedInfo;
  const fevent = bugo.fevent;
  const extra = groupExtraSchedulesByAnchor(deceasedInfo.extraSchedules);
  return (
    <>
      {deceasedInfo.enterance?.date && (
        <>
          <p className="font-bold text-gray-500">입실</p>
          <p className="font-normal">
            {formatFeventDateString(deceasedInfo.enterance, true, true)}
          </p>
        </>
      )}
      <ExtraScheduleRows list={extra.enterance} dayShow />
      {deceasedInfo.coffinIn?.date && (
        <>
          <p className="font-bold text-gray-500">입관</p>
          <p className="font-normal">
            {formatFeventDateString(deceasedInfo.coffinIn, true, true)}
          </p>
        </>
      )}
      <ExtraScheduleRows list={extra.coffinIn} dayShow />
      {deceasedInfo.coffinOut?.date && (
        <>
          <p className="font-bold text-gray-500">발인</p>
          <p className="font-normal">
            {formatFeventDateString(deceasedInfo.coffinOut, true, true)}
          </p>
        </>
      )}
      <ExtraScheduleRows list={extra.coffinOut} dayShow />
      {/* 장지: 1차·2차 배열이면 라벨별 줄(화장장/장지 등 사용자 라벨), 옛 문자열("A->B")은 "장지" 한 줄 그대로 */}
      {cemeteryDisplayRows(deceasedInfo).map((row, index) => (
        <Fragment key={`${index}-${row.label}-${row.name}`}>
          <p className="break-keep font-bold text-gray-500">{row.label}</p>
          <p className="font-normal">{row.name}</p>
        </Fragment>
      ))}

      <p className="font-bold text-gray-500">빈소</p>
      <p className="font-normal">
        {fevent.funeralHomeInfoEmbed?.name ?? fevent.funeralHomeInfo?.name}
      </p>

      <p className="font-bold text-gray-500">호실</p>
      <p className="font-normal">{fevent.roomInfoEmbed?.name}</p>

      {(bugo.mournerText || fevent.mournerText) && (
        <>
          <p className="font-bold leading-5 text-gray-500">
            상주
            <br />
            말씀
          </p>
          <p className="font-normal leading-5">
            {bugo.mournerText ? bugo.mournerText : fevent.mournerText}
          </p>
        </>
      )}
    </>
  );
};
